import React, { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";
import { message } from "antd";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const [formDetails, setFormDetails] = useState({
    name: "",
    email: "",
    mobile: "",
    desc: "",
  });
  const [loading, setIsLoading] = useState(false);

  const onFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const onlyNumbers = value.replace(/[^0-9]/g, "").slice(0, 10); // ✅ allows only digits up to 10
      setFormDetails((state) => ({ ...state, [name]: onlyNumbers }));
    } else {
      setFormDetails((state) => ({ ...state, [name]: value }));
    }
  };

const handleSubmit = (e) => {
    e.preventDefault(); // ✅ important to prevent page reload
    if (loading) return; // ✅ prevent double-submit
    setIsLoading(true);

    const templateParams = {
      name: formDetails.name,
      email: formDetails.email,
      mobile: formDetails.mobile,
      desc: formDetails.desc,
    };

    emailjs
      .send(
        "service_62yvdur",
        "template_yc2z2hb",  
        templateParams,
        "jRN3Qp0mMYEvkhNLm"
      )
      .then(
        () => {
          console.log("✅ Email sent successfully!");
          setIsLoading(false);
          setFormDetails({
            name: "",
            email: "",
            mobile: "",
            desc: "",
          });
          message.success("Mail sent successfully!");
        },
        (error) => {
          console.error("❌ Failed to send email:", error);
          setIsLoading(false);
          message.error("Something went wrong. Please try again later.");
        }
      );
  };

  return (
    <section id="contact" className="contact-section">
      <motion.div
        className="contact-container"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="contact-header">
          <h2>Let’s Connect with Catapult Media Work</h2>
          <p>We'd love to hear from you. Reach out to us anytime!</p>
        </div>

        <div className="contact-grid">
          {/* Contact Info */}
          <div className="contact-info">
            <div className="info-item">
              <Phone className="icon" />
              <span>+91 96556 36360</span>
            </div>
            <div className="info-item">
              <Mail className="icon" />
              <span>reshmakr@catapultmediawork.com</span>
            </div>
            <div className="info-item">
              <MapPin className="icon" />
              <span>
                A2/1, Phase 4, Vip Anugraha, Vanniyar St, Kolapakkam, Chennai 600128
              </span>
            </div>
          </div>

          {/* Contact Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="name"
                value={formDetails.name}
                onChange={onFormChange}
                placeholder="Your Name"
                required
              />
              <input
                type="email"
                name="email"
                value={formDetails.email}
                onChange={onFormChange}
                placeholder="Your Email"
                required
              />
            </div>
            <input
              type="text"
              name="mobile"
              value={formDetails.mobile}
              onChange={onFormChange}
              placeholder="Your Mobile"
              required
            />
            <textarea
              rows="5"
              name="desc"
              value={formDetails.desc}
              onChange={onFormChange}
              placeholder="Your Message..."
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </motion.div>
    </section>
  );
};

export default ContactUs;
